import React, { Component } from 'react'
import { Row, Col, Container, Form, Button, Table, Image, Card } from "react-bootstrap";
// import SelectDropDown from '../selectdropdown/SelectDropDown';
import SelectDropDown from '../../selectdropdown/SelectDropDown';
import { components } from 'react-select'
import moment, { invalid } from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import CardLessDataTable from '../../datatables/CardLessDataTableWithSearch';
import { withApollo } from "react-apollo";
import MultiSelect from "react-multi-select-component";
import MaterialStudentDetailsModal from './MaterialStudentDetailsModal';
import MaterialstoreCreationModal from './materialstoreCreationModal';


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class MaterialStoreHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            branchError: "",
            exam: "",
            examError: "",
            getExamArr: [],
            examSelectedvalue: [],
            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],
            materialType: "",
            materialTypeSearch: "0",
            materialTypeSearchval: "",
            materialTypeError: "",
            materialTypeDetails: [],
            loader: 0,
            rowData: [],
            materialTypesData: props.getMaterialTypes,
            getBranches: [],
            is_grouping: true,
            materialStoreData: [],
            materialStudentDetailsModal: false,
            submitted: false,
            noDateError: "",
            materialstoreCreationModal: false
        };
    }

    dropDownGetValues(fieldname, value) {
        let getArray = [];

        if (fieldname == "branchSearch") {
            this.props.globals.globalBranches.map((item) => {
                const newObj = {
                    value: item.id,
                    label: item.branch_name
                }
                getArray.push(newObj);
            });

        }

        if (fieldname == "materialTypeSearch") {
            this.state.materialTypesData.map((item1) => {
                const newObj = {
                    value: item1.id,
                    label: item1.material_type
                }
                getArray.push(newObj);
            })
        }

        return getArray;
    }

    selecthandleInputChange = (ename, evalue, e) => {

        console.log("nnnnn", e, ename);

        const name = ename;
        const value = evalue;

        let getExamArr = [];
        let getClassArr = [];

        //branch
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                })


                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getExamArr.push(newObj);
                });

                // if (!this.state.is_grouping) {
                //     this.getMaterials(value, "")
                // }

                //Class selection

                let selectedExamsValues = getExamArr.map((item) => item.value);

                let uniqueClasses = [];

                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        uniqueClasses.push(...individualClassValues)
                    });
                }

                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {
                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                }

                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branch: branchSearchData.branch_name,
                    branchSearch: branchSearchData.id,
                    getExamArr: getExamArr,
                    examSelectedvalue: getExamArr,
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    branchError: "",
                    materialStoreData: [],
                    noDateError: "",
                    examError: "",
                    classError: "",
                });
            } else {
                this.setState({
                    branchSearch: "0",
                    branchSearchval: "",
                    branchError: "",
                    getClasses: [],
                    getSections: [],
                    getExams: [],
                    materialStoreData: [],
                    noDateError: "",
                });
            }
        }

        if (name == "materialTypeSearch") {
            if (value != "0") {
                let getBranches = this.props.globals.globalBranches;

                let grouping = this.state.materialTypesData.find((item) => item.id == value).is_grouping == 1 ? true : false


                let materialTypeData = this.state.materialTypesData.find((a) => a.id == value);

                // console.log("materialTypeData", materialTypeData)

                this.setState({
                    materialTypeSearchval: {
                        value: materialTypeData.id,
                        label: materialTypeData.material_type
                    },
                    materialType: materialTypeData.material_type,
                    materialTypeSearch: materialTypeData.id,
                    materialTypeError: "",
                    getBranches: getBranches,
                    materialtypes: value,
                    is_grouping: grouping,
                    branch: "",
                    branchSearchval: "",
                    exam: "",
                    class: "",
                    getExamArr: [],
                    getClassArr: [],
                    examSelectedvalue: [],
                    classSelectedvalue: [],
                    examError: "",
                    classError: "",
                    branchError: "",
                    materialStoreData: [],
                    noDateError: "",
                })
            } else {
                this.setState({
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    branch: "",
                    branchSearchval: "",
                    exam: "",
                    class: "",
                    getExamArr: [],
                    getClassArr: [],
                    examSelectedvalue: [],
                    classSelectedvalue: [],
                    branchError: "",
                    examError: "",
                    classError: "",
                    getBranches: [],
                    materialtypes: 0,
                    is_grouping: true,
                    materialStoreData: [],
                    noDateError: "",
                });
            }
        }

        this.setState({ [name]: value });

    }

    handleMultipleSelectInputChange = (e, name) => {

        console.log("multipleChange", e, name);


        if (name == "class") {

            let classSelectedvalue = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }


                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    materialStoreData: [],
                    noDateError: "",
                });

                // this.getMaterials(this.state.branch, classSelectedvalue)

            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    materialStoreData: [],
                    noDateError: "",
                });
            }
        }

        if (name == "exam") {
            let examSelectedvalue = [];

            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const examval = e[i];
                    const newObj = {
                        label: examval.label,
                        value: examval.value,
                    }
                    examSelectedvalue.push(newObj);
                }


                let selectedExamsValues = examSelectedvalue.map((item) => item.value);

                let uniqueClasses = [];
                let getClassArr = [];


                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        console.log("individualClassValues", individualClassValues);
                        uniqueClasses.push(individualClassValues)
                    });
                }



                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses[0])].map((val) => {

                        console.log("uniqueClasses", val);

                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });
                }

                this.setState({
                    examSelectedvalue: examSelectedvalue,
                    examError: "",
                    classError: "",
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    materialStoreData: [],
                    noDateError: "",
                });
            } else {
                this.setState({
                    examSelectedvalue: [],
                    getClassArr: [],
                    classSelectedvalue: [],
                    materialStoreData: [],
                    noDateError: "",
                });
            }
        }
    }

    getMaterialTypes = async (val1, val2) => {
        const result = await this.props.client.query({
            query: gql`
            query($id:Int){
                getMaterialTypes(id:$id){
                    id
                    material_type
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val1),
                exam_id: parseInt(this.state.exam),
                class_id: parseInt(val2),
                material_type_id: parseInt(this.state.materialtypes)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterialTypes.length > 0) {
            let data = result.data.getMaterialTypes;
            // console.log("data", data)
            this.setState({ materialTypeDetails: data })
        } else {
            this.setState({ materialTypeDetails: [] })
        }
    }


    handleSubmit = async (e) => {

        if (this.state.materialType == "") {
            this.setState({ materialTypeError: "Please Select Material Type" });
            return ""
        }

        if (this.state.branch == "") {
            this.setState({ branchError: "Please Select Branch" });
            return ""
        }


        if (!this.state.examSelectedvalue.length) {
            this.setState({ examError: "Please Select Exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: "Please Select Class" });
            return ""
        }

        this.setState({ loader: 1 })


        const result = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int,$material_type_id:Int,$exam_id:String,$class_id:String){
                getMaterialStoreReport(institute_id:$institute_id,branch_id:$branch_id,material_type_id:$material_type_id,exam_id:$exam_id,class_id:$class_id){

                    material_id
                    material_name
                    bec
                    total_students
                    total_quantity {
                      material_count
                      material_received_date
                    }
                    total_quantity_count
                    required_quantity_count
                    excess_quantity_count
                    delivered_count
                    not_delivered_count
                      
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                material_type_id: parseInt(this.state.materialTypeSearch),
                branch_id: parseInt(this.state.branchSearch),
                exam_id: this.state.is_grouping == true ? this.state.examSelectedvalue.map((item) => item.value).toString() : null,
                class_id: this.state.is_grouping == true ? this.state.classSelectedvalue.map((item) => item.value).toString() : null,
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterialStoreReport.length > 0) {

            console.log("dataaaaaaaaaaaaa", result.data.getMaterialStoreReport);
            let data = result.data.getMaterialStoreReport

            this.setState({ materialStoreData: data, loader: 0, submitted: true })

        } else {
            this.setState({ loader: 0, noDateError: "No Data Available" })
        }


    }



    articlecolumns = [
        {
            dataField: "material_name",
            text: "Material",
            sort: true,
        },
        {
            dataField: "bec",
            text: "Exam/Class/Section",
            sort: true,
        },
        {
            dataField: "total_Students",
            text: "Total Students",
            sort: true,
        },
        {
            dataField: "total_quantity",
            text: "Total Quantity",
            sort: true,
            formatter: this.materialStudentData.bind(this),
        },
        {
            dataField: "req_quantity",
            text: "Req Quantity",
            sort: true,
        },
        {
            dataField: "excess_quantity",
            text: "Excess Quantity",
            sort: true,
        },
        {
            dataField: "delivered",
            text: "Delivered",
            sort: true,
        },
        {
            dataField: "pending",
            text: "Not Delivered",
            sort: true,
        },

    ];



    materialStudentData(val, row) {
        console.log("numberrrrrr", row)

        return (<>
            <div>
                {

                    <a href="#" onClick={() => { this.setState({ materialStudentDetailsModal: true, rowData: row }) }}>
                        {val}
                    </a>

                }
            </div>
        </>)

    }


    tableData(data) {
        console.log("data", data);
        let returnData = [];


        data.map((mapData) => {

            const newObj = {
                material_name: mapData.material_name,
                bec: mapData.bec,
                total_Students: mapData.total_students,
                total_quantity: mapData.total_quantity_count,
                req_quantity: mapData.required_quantity_count,
                excess_quantity: mapData.excess_quantity_count,
                delivered: mapData.delivered_count,
                pending: mapData.not_delivered_count,
                totalQuantityData: mapData.total_quantity
            }
            returnData.push(newObj);
        });

        return returnData;
    }


    render() {

        console.log("baaaade", this.state)


        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "class"
        }


        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "exam"
        }


        return (
            <section className="material_store">
                <Container>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0 mt-5">Material Store Report</h2>
                                <div className='d-flex justify-content-end'>
                                    <div className='d-flex justify-content-end' style={{ marginTop: "30px" }}>
                                        <button className="text-uppercase mat_ass" onClick={() => { this.setState({ materialstoreCreationModal: true }) }}>Material Update</button></div>
                                </div>
                            </div>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12} className="studentTable">
                            <Card className="border-0 shadow-sm mb-4 ">
                                <Card.Header>
                                    <Row>
                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Material Type</h6>
                                            <SelectDropDown
                                                stateData={this.state.materialTypeSearchval}
                                                handleChange={this.selecthandleInputChange}
                                                name="materialTypeSearch"
                                                options={this.dropDownGetValues("materialTypeSearch")}
                                                placeholderName={'Material Type'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                            <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.materialTypeError}</span>
                                        </Col>

                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Branch </h6>
                                            <SelectDropDown
                                                stateData={this.state.branchSearchval}
                                                handleChange={this.selecthandleInputChange}
                                                name="branchSearch"
                                                options={this.dropDownGetValues("branchSearch")}
                                                placeholderName={'Branch'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                            <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.branchError}</span>
                                        </Col>

                                        {
                                            this.state.is_grouping ? (
                                                <>
                                                    <Col lg={2} md={12} sm={12}>
                                                        <h6>Exam </h6>
                                                        <MultiSelect
                                                            overrideStrings={{
                                                                "allItemsAreSelected": "All Exams are selected.",
                                                                "selectSomeItems": examlabelledBy
                                                            }
                                                            }
                                                            disableSearch={examdisableSearch}
                                                            hasSelectAll={examselectall}
                                                            options={this.state.getExamArr}
                                                            value={this.state.examSelectedvalue}
                                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                                            labelledBy={"exam"}
                                                        />
                                                        <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.examError}</span>
                                                    </Col>

                                                    <Col lg={2} md={12} sm={12}>
                                                        <h6>Class </h6>
                                                        <MultiSelect
                                                            overrideStrings={{
                                                                "allItemsAreSelected": "All Class are selected.",
                                                                "selectSomeItems": classlabelledBy
                                                            }
                                                            }
                                                            disableSearch={classdisableSearch}
                                                            hasSelectAll={classselectall}
                                                            options={this.state.getClassArr}
                                                            value={this.state.classSelectedvalue}
                                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                                            labelledBy={"class"}
                                                        />
                                                        <span
                                                            className="text-danger" style={{ fontSize: "12px" }}>{this.state.classError}</span>
                                                    </Col>
                                                </>
                                            ) : ("")
                                        }

                                        <Col lg={4} md={12} sm={12}>
                                            <Button style={{ backgroundColor: "#213046", color: "#ffffff" }} className="text-uppercase mt-4 ml-4" onClick={this.handleSubmit}>Submit</Button>
                                        </Col>
                                    </Row>
                                </Card.Header>

                                {
                                    this.state.materialStoreData.length > 0 ?
                                        (
                                            <Card.Body>
                                                <Container fluid className='materialstore'>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <CardLessDataTable
                                                                parentData={this.tableData(this.state.materialStoreData)}
                                                                particlecolumns={this.articlecolumns}
                                                                name="attendance"
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Card.Body>

                                        ) : <Row>
                                            {
                                                <>
                                                    <Col sm={12}>
                                                        <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                                    </Col>
                                                    <Col sm={12}>
                                                        {
                                                            this.state.noDateError != "" ?
                                                                (
                                                                    <h6 className='d-flex justify-content-center align-content-center mt-3'>{this.state.noDateError}</h6>
                                                                )
                                                                :
                                                                ("")
                                                        }
                                                    </Col>
                                                </>
                                            }
                                        </Row>
                                }

                            </Card>

                        </Col>
                    </Row>
                    <MaterialStudentDetailsModal
                        stateData={this.state}
                        show={this.state.materialStudentDetailsModal}
                        onHide={() => this.setState({ materialStudentDetailsModal: false })}

                    />
                    <MaterialstoreCreationModal
                        globals={this.props.globals}
                        stateData={this.state}
                        show={this.state.materialstoreCreationModal}
                        onHide={() => this.setState({ materialstoreCreationModal: false })}
                        getMaterialTypes={this.props.getMaterialTypes}
                    />
                </Container>
            </section>
        )
    }
}

export default withRouter(withApollo(compose(

)(MaterialStoreHome))
);